import React, { Component } from 'react'
import Link from 'gatsby-link'
import Menu from '../Menu'
import logo from './logo.png'
import scripts from './scripts.js'

class Header extends Component {

  componentDidMount() {
    scripts();
  }

  render() {
    const { pages, pathContext } = this.props;

    const topMenuItems = pages.edges.filter((page) => {
      return !page.node.context.parent;
    });

    return (
      <div className="header">
        <Link className="logo" to="/" ><img src={logo} alt="" /></Link>
        <Menu nodes={topMenuItems} pages={pages} pathContext={pathContext} />
      </div>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/index.js